import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsElasticcloudComponent } from './simple-icons-elasticcloud.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsElasticcloudComponent ],
    exports:      [ SimpleIconsElasticcloudComponent ],
    bootstrap:    []
})
export class SimpleIconsElasticcloudModule {}
